import axios from "axios";
const base_path = window.APP_CONFIG?.BASE_URL;

//get all
export const getAllCart = async (UserGuId) => {
  const response = await axios.get(`${base_path}/api/Cart/GetAll?UserGuId=${UserGuId}`);
  return response.data;
};
//Add
export const addProductToUserCart = async (cartData) => {
  await axios.post(`${base_path}/api/Cart/Save`, cartData);
  //return response.data;
};

//remove
export const removeProductFromUserCart = async (cartData) => {
  const response= await axios.post(`${base_path}/api/Cart/Delete`,cartData)
  return response.data;
 };
//update
 export const updateUserCart = async (cartData) => {
  const response = await axios.post(`${base_path}/api/Cart/Update`,cartData);
  return response.data;
};
//clear cart
export const clearUserCart = async (cartData) => {
  const response =  await axios.post(`${base_path}/api/Cart/ClearCart`,cartData);
  return response.data;
};